import queryString from 'query-string';

const POST_FEED_TYPES = ['timeline', 'services'];

const validFeedType = (feedType) =>
	POST_FEED_TYPES.includes(feedType) ? feedType : null;

export const getPostIntentSearch = (feedType) =>
	feedType === 'services' ? '?feedType=services' : '';

export const getRequestedPostFeedType = (search, locationState) => {
	const queryFeedType = queryString.parse(search || '').feedType;
	return (
		validFeedType(queryFeedType) || validFeedType(locationState?.feedType)
	);
};

export const resolveNspId = ({ nsp, nspId } = {}) => nspId || nsp?.id || null;

export const isServicePostState = (postState) =>
	Boolean(postState?.nsp || resolveNspId(postState));

export const getServiceTemplateState = (template, change = {}) => ({
	title: template.title || '',
	category: template.category?.id || template.category || '',
	nsp: template,
	nspId: template.id,
	nspDescription: template.description || null,
	servicesCategory: template.servicesCategory || null,
	sgpId: null,
	change: {
		...change,
		title: true,
		category: true,
		nspId: true,
		servicesCategory: true,
		sgpId: true,
	},
});

export const getClearedServiceState = (change = {}) => ({
	nsp: false,
	nspId: null,
	nspDescription: null,
	servicesCategory: null,
	change: {
		...change,
		nsp: true,
		nspId: true,
		servicesCategory: true,
	},
});
